import {sx} from './sx'
import {Box, Tab, Tabs} from "@mui/material";
import TabPanel from "@ui/tabsCustom/TabPanel";
import React, {FC, ReactNode} from 'react'
import {SxType} from "@baseTypes/sx/sxTypes";
import {ITabItem} from "@ui/tabsCustom/types";
import {a11yProps} from "@ui/tabsCustom/helpers";

interface ITabsProps {
	tabs: ITabItem[],
	sx?: SxType,
	initial?: number,
	value?: number,
	onChange?: (value: number) => void,
	headerChildren?: ReactNode
}

const TabsCustom: FC<ITabsProps> = ({
										tabs,
										sx: sxProps = {},
										initial,
										value: valueControl,
										onChange,
										headerChildren
									}) => {
	
	const [value, setValue] = React.useState(initial || 0);
	
	const handleChange = (event: React.MouseEvent<HTMLButtonElement>, newValue: number) => {
		setValue(newValue);
		if (onChange) {
			onChange(newValue)
		}
	};
	
	
	const currentValue = (tabs?.length - 1 < value) ? tabs?.length - 1 : value;
	
	const tabsList = tabs?.map((item, i) => {
		const {label, index} = item;
		return (
			<Tab
				key={index || i}
				sx={sx.tabHeader}
				className={'tabsHeaderCustomItem'}
				label={label}
				{...a11yProps(index || i)}
			/>
		)
	})
	
	const tabsPanelList = tabs?.map((item, i) => {
		const {component, index} = item;
		return (
			<TabPanel
				key={index || i}
				value={valueControl || currentValue}
				index={index || i}
			>
				{component}
			</TabPanel>
		)
	})
	
	return (
		<Box sx={{
			...sx.root,
			...sxProps,
			
		} as SxType}>
			<Box
				sx={sx.inner}
				className={'tabsHeaderInner'}
			>
				<Tabs
					className={'tabsHeaderCustom'}
					sx={sx.header} value={valueControl || currentValue}
					scrollButtons={false}
					onChange={handleChange}
				>
					{tabsList}
				</Tabs>
				
				{headerChildren && headerChildren}
			</Box>
			
			<Box sx={sx.content}>
				{tabsPanelList}
			</Box>
		</Box>
	);
};
export default TabsCustom;